
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import {
  API_TTeammates_Pending,
  convertTeammatesPendingForTable,
} from "@/models/company_teammates";
import { SMTeammates } from "@/store";

@Component({
  components: {
    InviteTeammate: () => import("@/modules/Compliance/Teammates/InviteTeammate.vue"),
    PendingInvitesTable: () => import("@/modules/Compliance/Teammates/PendingInvitesTable.vue"),
    TeammatesTable: () => import("@/modules/Compliance/Teammates/TeammatesTable.vue"),
  },
})
export default class TeammatesBrowse extends Vue {
  loadingPending = false;

  loading = false;

  teammatesPending: API_TTeammates_Pending[] = [];

  get teammates() {
    return SMTeammates.teammates;
  }

  async mounted() {
    await this.getTeammatesPending();

    this.getTeammates();
  }

  async getTeammates() {
    await SMTeammates.getTeammates();
  }

  async getTeammatesPending() {
    try {
      this.loadingPending = true;

      const { data } = await this.axios.get(API_ROUTES.COMPANY_INVITE);

      if (!data) return;

      this.teammatesPending = data.map((a: API_TTeammates_Pending) =>
        convertTeammatesPendingForTable(a)
      );
    } finally {
      this.loadingPending = false;
    }
  }
}
